import { request } from "@ygtechnologies/bygr-frontend-component-library";
import { OptionGroupFilterData } from "./optionGroups.types";

export function getOptionGroupFilterData(projectId: number): Promise<OptionGroupFilterData> {
    return request(`api/option-group/${projectId}/filter-data`).then((x) => x.json());
}